import React, { Component } from 'react'
import {
  Table,
  TableBody,
  TableRow,
  TableCell,
  Button,
  withStyles,
  TableHead,
  Grid
} from '@material-ui/core'
import { useTranslation } from 'react-i18next'

import { useForm, Form, Field, WatchField } from '../../form'
import { adminCustomerValidate } from '../../containers/validate'
import WorkField from '../common/fieldOfWorkSelect'
import { defaultValues as taxCardDefaultValues } from '../profile/tax.component'
import { GenericNumberInput } from '../../utils/numberFormat'

const styles = (theme) => ({
  textField: {
    fontSize: '15px',
    marginTop: theme.spacing(4)
    // border: '1px solid gray'
  },
  textArea: {
    fontSize: '15px',
    marginTop: theme.spacing(3),
    paddingTop: theme.spacing(1),
    lineHeight: '16px',
    height: '100px'
  },
  checkbox: {
    fontSize: '15px',
    fontWeight: 'bold',
    color: '#808080'
  },
  checkbox1: {
    fontSize: '15px',
    color: '#808080'
  },
  tableCell: {
    border: 'none',
    padding: theme.spacing(2)
  },
  tableHead: {
    border: 'none',
    margin: '0px',
    padding: '0px'
  },
  radioButton: {
    fontSize: '14px'
  },
  select: {
    fontSize: '14px'
  }
})

class AdminUserForm extends Component {
  render() {
    return <AdminUserFormComponent {...this.props} />
  }
}

export default withStyles(styles)(AdminUserForm)

const defaultValues = {
  account_number: '',
  city: '',
  address: '',
  phone: '',
  firstname: '',
  lastname: '',
  zip_code: '',
  ssn: '',
  job_title: '',
  market_name: '',
  service_payment: '',
  tax_percentage: '',
  yel_percentage: '',
  yel_income: '',
  age_group: '',
  yelSelect: '',
  created: '',
  firsttime_enterprenuer: false,
  useMarketName: false,
  isgovpay: false,
  ismanualgovpay: false,
  isnormalgovpay: false,
  isbruttogovpay: false,
  maxmonthlygovpay: 0,
  notes: '',
  salary_payment_option: '',
  //salary_payment_option: 'manual_pay',
  field_work: '',
  taxCard_number: '',
  taxCard_unit: '',
  taxCard_zip_code: '',
  taxCard_address: '',
  taxCard_city: '',
  taxCard_inputPicture: '',
  construction: false,
  shipbuilding: false,
  tax_card: '',
  withdrawal_account_number: '',
  withdrawal_reference_number: '',
  payment_ban_number: '',
  amount_raised: ''
}

const AdminUserFormComponent = ({
  email,
  updateAdminUser,
  handleChangeAdminMenu,
  searchCompanyInvoices,
  searchCompanySalaries,
  index,
  initialValues,
  classes,
  fieldOfWork,
  taxCard,
  user
}) => {
  const [picture, setPicture] = React.useState('')
  const { t } = useTranslation()

  const form = useForm({
    name: 'adminForm' + index,
    onSubmit: onSubmit,
    defaultValues: {
      ...defaultValues,
      ...replaceNullsWithStrings(initialValues),
      ...(taxCard ? taxCard : taxCardDefaultValues),
      amount_raised: user.invoicedUserInvoices
    },
    resetOnSubmit: false,
    validator: adminCustomerValidate
  })

  const { control, clearErrors } = form

  function onSubmit(values) {
    updateAdminUser(values)
  }

  function handleLaskutPress(value, email) {
    handleChangeAdminMenu(value)
    searchCompanyInvoices(email)
  }

  function handleSalariesPress(value, email) {
    handleChangeAdminMenu(value)
    searchCompanySalaries(email)
  }

  // Preview image when it is uploaded
  const imageHandler = (e) => {
    e.preventDefault()
    const reader = new FileReader()
    const file = e.target.files[0]
    if (file !== undefined) {
      reader.onload = () => {
        if (reader.readyState === 2) {
          setPicture(reader.result)
        }
      }
      reader.readAsDataURL(file)
    }
  }
  //
  React.useEffect(() => {
    if (initialValues.industryTaxInfo !== '') {
      setPicture(initialValues.filePath)
    } else {
      setPicture('')
    }
  }, [initialValues, setPicture])

  // Tax card disabled when there is no tax card is send from customer
  const isDisabled = initialValues.industryTaxInfo === '' ? true : false

  return (
    <Form {...form}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell
              style={{ width: '30%' }}
              className={classes.tableHead}
            ></TableCell>
            <TableCell
              style={{ width: '25%' }}
              className={classes.tableHead}
            ></TableCell>
            <TableCell
              style={{ width: '25%' }}
              className={classes.tableHead}
            ></TableCell>
            <TableCell
              style={{ width: '20%' }}
              className={classes.tableHead}
            ></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell className={classes.tableCell}>
              <Field
                name="firstname"
                label="Etunimi*"
                inputType="textfield"
                className={classes.textField}
                control={control}
              />
            </TableCell>
            <TableCell className={classes.tableCell}>
              <Field
                name="lastname"
                inputType="textfield"
                className={classes.textField}
                control={control}
                label="Sukunimi*"
              />
            </TableCell>
            <TableCell className={classes.tableCell}>
              <Field
                name="ssn"
                inputType="textfield"
                className={classes.textField}
                control={control}
                label="Henkilötunnus*"
                disabled={Boolean(initialValues?.ssn)}
              />
            </TableCell>
            <TableCell className={classes.tableCell}>
              <Field
                name="account_number"
                inputType="textfield"
                className={classes.textField}
                control={control}
                label="Tilinumero*"
                disabled={initialValues.roleid === 3 ? true : false}
              />
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell className={classes.tableCell}>
              <Field
                name="address"
                inputType="textfield"
                className={classes.textField}
                control={control}
                label="Osoite*"
              />
            </TableCell>
            <TableCell className={classes.tableCell}>
              <Field
                name="zip_code"
                inputType="textfield"
                className={classes.textField}
                control={control}
                label="Postinumero*"
              />
            </TableCell>
            <TableCell className={classes.tableCell}>
              <Field
                name="city"
                inputType="textfield"
                className={classes.textField}
                control={control}
                label="Postitoimipaikka*"
              />
            </TableCell>
            <TableCell className={classes.tableCell}>
              <Field
                name="phone"
                inputType="textfield"
                className={classes.textField}
                control={control}
                label="Puhelinnumero*"
              />
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell className={classes.tableCell}>
              <Field
                name="job_title"
                inputType="textfield"
                className={classes.textField}
                control={control}
                label="Ammattinimike"
              />
            </TableCell>
            <TableCell className={classes.tableCell}>
              <WatchField control={control} fields="useMarketName">
                {(watch) => (
                  <Field
                    name="market_name"
                    inputType="textfield"
                    className={classes.textField}
                    control={control}
                    label={
                      watch.useMarketName === true
                        ? 'Markkinointinimi' + '*'
                        : 'Markkinointinimi'
                    }
                  />
                )}
              </WatchField>
            </TableCell>
            <TableCell className={classes.tableCell}>
              <WorkField
                classes={classes}
                fieldOfWork={fieldOfWork}
                control={control}
                disabled={true}
              />
            </TableCell>
            <TableCell className={classes.tableCell}>
              <Field
                name="created"
                inputType="textfield"
                className={classes.textField}
                control={control}
                label="Rekisteröitymispäivä"
                disabled={true}
              />
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell className={classes.tableCell}>
              <Field
                name="yel_percentage"
                inputType="textfield"
                className={classes.textField}
                control={control}
                label="YEL-prosentti"
                disabled={true}
              />
            </TableCell>
            <TableCell className={classes.tableCell}>
              <Field
                name="yel_income"
                inputType="textfield"
                className={classes.textField}
                control={control}
                label="YEL-työtulo"
                disabled={true}
              />
            </TableCell>
            <TableCell className={classes.tableCell}>
              <Field
                name="age_group"
                inputType="textfield"
                className={classes.textField}
                control={control}
                label="Ikäluokka"
                disabled={true}
              />
            </TableCell>
            <TableCell className={classes.tableCell}>
              <Field
                name="yelSelect"
                inputType="textfield"
                className={classes.textField}
                control={control}
                label="valitseYEL"
                disabled={true}
              />
            </TableCell>
          </TableRow>
          <TableRow>
            {/*
            { <TableCell className={classes.tableCell}>
              <div>
                <p
                  style={{
                    marginTop: '22px',
                    color: '#696969',
                    fontSize: '15px'
                  }}
                >
                  Palkan maksutapa
                </p>
                <Field
                  name="salary_payment_option"
                  inputType="radiogroup"
                  className={classes.radioButton}
                  options={[
                    {
                      label: 'Manuaalinen palkanmaksu',
                      value: 'manual_pay'
                    },
                    {
                      label: 'Palkka maksetaan automaattisesti',
                      value: 'auto_pay'
                    }
                  ]}
                  control={control}
                />
              </div>
            </TableCell> }
 */}
            <TableCell className={classes.tableCell}>
              <Field
                name="firsttime_enterprenuer"
                label="Olen toiminut yrittäjänä alle neljä vuotta."
                inputType="checkbox"
                className={classes.checkbox}
                control={control}
                disabled={true}
              />
              <WatchField
                control={control}
                fields={[
                  'isgovpay',
                  'ismanualgovpay',
                  'isnormalgovpay',
                  'isbruttogovpay'
                ]}
              >
                {(watch) => (
                  <Grid item xs={6}>
                    <Field
                      name="isgovpay"
                      label="Ulosotto"
                      inputType="checkbox"
                      className={classes.checkbox}
                      control={control}
                      disabled={
                        watch.ismanualgovpay ||
                        watch.isnormalgovpay ||
                        watch.isbruttogovpay
                      }
                    />
                    <Field
                      name="ismanualgovpay"
                      label="Manuaalinen Ulosotto"
                      inputType="checkbox"
                      className={classes.checkbox}
                      control={control}
                      disabled={
                        watch.isgovpay ||
                        watch.isnormalgovpay ||
                        watch.isbruttogovpay
                      }
                    />
                    <Field
                      name="isnormalgovpay"
                      label="Normaali ulosotto"
                      inputType="checkbox"
                      className={classes.checkbox}
                      control={control}
                      disabled={
                        watch.ismanualgovpay ||
                        watch.isgovpay ||
                        watch.isbruttogovpay
                      }
                    />
                    <Field
                      name="isbruttogovpay"
                      label="1/6 brutto ulosotto"
                      inputType="checkbox"
                      className={classes.checkbox}
                      control={control}
                      disabled={
                        watch.ismanualgovpay ||
                        watch.isgovpay ||
                        watch.isnormalgovpay
                      }
                    />
                  </Grid>
                )}
              </WatchField>
            </TableCell>
            <TableCell className={classes.tableCell}>
              <Field
                name="maxmonthlygovpay"
                label="Ulosotto max"
                inputType="textfield"
                inputComponent={GenericNumberInput}
                className={classes.textField}
                control={control}
              />
            </TableCell>
            <TableCell className={classes.tableCell}>
              <Field
                name="useMarketName"
                label="Haluan käyttää ainoastaan markkinointinimeäni laskuissa."
                inputType="checkbox"
                className={classes.checkbox}
                control={control}
              />
            </TableCell>
          </TableRow>
          {/* Industry tax card table row goes here */}
          <TableRow style={{ backgroundColor: '#EDEEEC' }}>
            <TableCell>
              <Field
                name="taxCard_number"
                inputType="textfield"
                className={classes.textField}
                control={control}
                label="Veronumero*"
                disabled={isDisabled}
              />
            </TableCell>
            <TableCell>
              <Field
                name="taxCard_unit"
                inputType="textfield"
                className={classes.textField}
                control={control}
                label="Apartment number"
                disabled={isDisabled}
              />
            </TableCell>
            <TableCell>
              <Field
                name="taxCard_zip_code"
                inputType="textfield"
                className={classes.textField}
                control={control}
                label="Postal code*"
                disabled={isDisabled}
              />
            </TableCell>
            <TableCell rowSpan={2}>
              <div
                className="picture"
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  position: 'relative'
                }}
              >
                <div style={{ marginTop: 'auto' }}>
                  <div>
                    <img
                      src={picture}
                      className="img-fluid img-thumbnail"
                      style={{
                        aspectRatio: '3 / 4',
                        minWidth: '150px',
                        backgroundColor: '#F5F5F5'
                      }}
                    ></img>
                  </div>
                </div>
                <div style={{ padding: '15px' }}></div>
                <div style={{ marginTop: 'auto' }}>
                  <div>
                    <Button
                      variant="contained"
                      className={classes.buttonFile}
                      component="label"
                      htmlFor="input-image"
                      style={{ width: '120px' }}
                      disabled={isDisabled}
                    >
                      Add picture
                    </Button>
                  </div>
                  <div className="dashboard-tax-input">
                    <Field
                      name="taxCard_inputPicture"
                      inputType="file"
                      id="input-image"
                      control={control}
                      accept="image/*"
                      onChange={imageHandler}
                      disabled={isDisabled}
                    />
                  </div>
                </div>
              </div>
            </TableCell>
          </TableRow>
          <TableRow style={{ backgroundColor: '#EDEEEC' }}>
            <TableCell>
              <Field
                name="taxCard_address"
                inputType="textfield"
                className={classes.textField}
                control={control}
                label="Card Delivery Address*"
                disabled={isDisabled}
              />
            </TableCell>
            <TableCell>
              <Field
                name="taxCard_city"
                inputType="textfield"
                className={classes.textField}
                control={control}
                label="City*"
                disabled={isDisabled}
              />
            </TableCell>
            <TableCell>
              <div style={{ display: 'flex' }}>
                <div>
                  <Field
                    name="construction"
                    inputType="checkbox"
                    className={classes.checkbox1}
                    control={control}
                    label="Construction"
                    disabled={isDisabled}
                  />
                </div>
                <div>
                  <Field
                    name="shipbuilding"
                    inputType="checkbox"
                    className={classes.checkbox1}
                    control={control}
                    label="Shipbuilding"
                    disabled={isDisabled}
                    onChange={(e) => {
                      if (e.target.checked) {
                        clearErrors(['construction'])
                      }
                    }}
                  />
                </div>
              </div>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell className={classes.tableCell}>
              <Field
                name="startingBalance"
                label={t('taxComponent.startingBalance')}
                inputType="textfield"
                control={control}
                className={classes.textField}
                disabled={true}
              />
            </TableCell>
            <TableCell className={classes.tableCell}>
              <Field
                name="incomeLimit"
                label={t('taxComponent.incomeLimit')}
                inputType="textfield"
                control={control}
                className={classes.textField}
                disabled={true}
              />
            </TableCell>
            <TableCell className={classes.tableCell}>
              <Field
                name="withholdingPercentage"
                label="Perusveroprosentti"
                inputType="textfield"
                control={control}
                className={classes.textField}
                disabled={true}
              />
            </TableCell>
            <TableCell className={classes.tableCell}>
              <Field
                name="additionalPercentage"
                label={t('taxComponent.additionalPercentage')}
                inputType="textfield"
                control={control}
                className={classes.textField}
                disabled={true}
              />
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell className={classes.tableCell}>
              <Field
                name="validFrom"
                label="Verokortin voimaantulopäivä"
                disabled={true}
                inputType="datepicker"
                control={control}
                className={classes.textField}
              />
            </TableCell>
            <TableCell className={classes.tableCell}>
              <Field
                name="tax_card"
                label={t('taxComponent.tax_card')}
                inputType="textfield"
                control={control}
                className={classes.textField}
              />
            </TableCell>
            <WatchField
              control={control}
              fields={[
                'isgovpay',
                'ismanualgovpay',
                'isnormalgovpay',
                'isbruttogovpay'
              ]}
            >
              {(watch) => {
                const isGovpaySelected = 
                  watch.isgovpay || 
                  watch.ismanualgovpay || 
                  watch.isnormalgovpay || 
                  watch.isbruttogovpay

                return (
                  <>
                    <TableCell className={classes.tableCell}>
                      <Field
                        name="withdrawal_account_number"
                        label={`${
                          t('taxComponent.withdrawal_account_number')
                        } ${
                          isGovpaySelected ? '*' : ''
                        }`}
                        inputType="textfield"
                        control={control}
                        className={classes.textField}
                        disabled
                      />
                    </TableCell>
                    <TableCell className={classes.tableCell}>
                      <Field
                        name="withdrawal_reference_number"
                        label={`${
                          t('taxComponent.withdrawal_reference_number')
                        }`}
                        inputType="textfield"
                        control={control}
                        className={classes.textField}
                      />
                    </TableCell>
                  </>
                )
              }}
            </WatchField>
          </TableRow>
          <TableRow>
            <TableCell className={classes.tableCell}>
              <Field
                name="payment_ban_number"
                label={t('taxComponent.payment_ban_number')}
                inputType="textfield"
                control={control}
                className={classes.textField}
              />
            </TableCell>
            <TableCell className={classes.tableCell}>
              <Field
                name="amount_raised"
                inputType="textfield"
                className={classes.textField}
                control={control}
                label="Amount raised"
                disabled={true}
              />
            </TableCell>
            <TableCell className={classes.tableCell}>
              <Field
                name="service_payment"
                inputType="textfield"
                className={classes.textField}
                control={control}
                label="Palvelumaksuprosentti"
                disabled={true}
              />
            </TableCell>
            <TableCell className={classes.tableCell}>
              <Field
                name="tax_percentage"
                inputType="textfield"
                className={classes.textField}
                control={control}
                label="Aktiivinen veroprosentti"
              />
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell colSpan={4} className={classes.tableCell}>
              <Field
                name="notes"
                inputType="textfield"
                className={classes.textArea}
                control={control}
                label="Lisäkommentit"
                multiline
              />
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell colSpan={4} className={classes.tableCell}>
              <Field
                name="salary_notes"
                inputType="textfield"
                className={classes.textArea}
                control={control}
                label="Lisäkommentit Palkat"
                multiline
                disabled
              />
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell colSpan={4} className={classes.tableCell}>
              <ul className="nav nav-pills pull-right">
                <li>
                  <Button
                    className="pull-right"
                    variant="contained"
                    onClick={() => handleSalariesPress(2, email)}
                  >
                    Palkat
                  </Button>
                </li>
                <li style={{ marginRight: '15px' }}>
                  <Button
                    className="pull-right"
                    variant="contained"
                    onClick={() => handleLaskutPress(1, email)}
                  >
                    Laskut
                  </Button>
                </li>
                <li>
                  <Button
                    className="pull-right"
                    type="submit"
                    variant="contained"
                  >
                    Tallenna
                  </Button>
                </li>
              </ul>
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </Form>
  )
}

function replaceNullsWithStrings(obj) {
  const newObj = {}
  Object.keys(obj).forEach((key) => {
    newObj[key] = obj[key] === null ? '' : obj[key]
  })
  return newObj
}
